<template>
  <dashboard-modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    :hide-footer="true"
    :hide-header="true"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="`/agreementadministrator/agreement/store/${inputs.id}`"
      >
        <div class="form-group" style="text-align: center">
          <h5 class="text-primary">¿El convenio está vigente?</h5>
          <app-input
            type="radio-buttons"
            v-model="is_in_force"
            :required="true"
            :list="list"
          />
          <br />
        </div>

        <div class="form-group row align-items-center" v-if="is_in_force == 0">
          <label for="inputs_name" class="col-sm-12 mb-0">
            {{ $t("Observaciones") }}
          </label>
          <app-input
            id="inputs_name"
            class="col-sm-12"
            type="textarea"
            v-model="inputs.observation_approval_evaluation"
          />
        </div>

        <div class="card card-with-shadow border-0 mb-primary">
          <div class="card-header p-primary bg-transparent">
            <h5 class="card-title m-0">Convenio</h5>
          </div>
          <div class="card-body">
            <div class="form-group mb-primary row align-items-center">
              <div class="col-sm-12 text-center">
                <a
                  :href="inputs.deposit_attach"
                  class="btn btn-success"
                  target="_blank"
                >
                  <app-icon name="file"></app-icon> Ver
                </a>
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
  </dashboard-modal>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import { ModalMixin } from "@/app/Mixins/ModalMixin";

export default {
  name: "DepositModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  hide: false,
  data() {
    return {
      preloader: false,
      hide: false,
      inputs: {},
      is_in_force: 1,
      list: [
        {
          id: "0",
          value: "No",
        },
        {
          id: "1",
          value: "Si",
        },
      ],
      modalId: "evaluation-testification-add-edit-modal",
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("Verificación de convenio vigente");
      this.preloader = true;
    }
  },
  methods: {
    submit() {
      var request = {};
      request["is_in_force"] = this.is_in_force;
      request["eval_test_id"] = this.inputs.eval_test_id;
      request["observation"] = this.inputs.observation_approval_evaluation;
      this.save(request);
      // this.afterSuccess();
    },
    afterSuccess() {
      this.$toastr.s("Registro actualizado exitosamente.");

      this.$hub.$emit("reload-" + this.tableId);
    },
    afterSuccessFromGetEditData(response) {
      if (response.data.is_approved === 3) {
        this.hide = true;
      }
      this.inputs = response.data;
      // console.log(this.inputs.);
      // this.inputs.bank = response.data.bank.name;
      // this.inputs.amount = response.data.amount + ' USD';
      // this.inputs.transactiontype = response.data.transactiontype.name;
      // this.inputs.oec = response.data.accreditation_application.organization.name;
      // this.inputs.taxid = response.data.accreditation_application.organization.taxid;
      // this.inputs.is_approved = false;
      // this.inputs.eval_test_id = response.data.eval_test_id;
      this.preloader = false;
      if (response.data.file) {
        this.inputs.deposit_attach = response.data.file.full_url;
      } else {
        this.inputs.deposit_attach = "";
      }
      this.preloader = false;
    },
  },
};
</script>